import React, {useState, useEffect} from 'react';
import ReactGA from 'react-ga';

import {getCurrentStep} from '../network';

import '../App.css';
import Welcome from "./FormSteps/Welcome";
import SubjectIntroduction from "./FormSteps/SubjectIntroduction";
import TeacherAndStudents from "./FormSteps/TeacherAndStudents";
import SubjectContent from "./FormSteps/SubjectContent";
import TimelineAndGrading from "./FormSteps/TimelineAndGrading";
import MutualAgreement from "./FormSteps/MutualAgreement";
import Thanks from "./FormSteps/Thanks";
import FormSubmitted from "./FormSteps/FormSubmitted";
import StudentProfiles from "./FormSteps/StudentProfiles";

const maxStep = 8;
const googleAnalyticsID = process.env.REACT_APP_GA_ID;

function App() {
    const [currentFormStep, setCurrentFormStep] = useState(0);
    const nextStep = () => {
        if (currentFormStep < maxStep) {
            setCurrentFormStep(currentFormStep + 1);
            window.scrollTo(0, 0);
        }
    };

    useEffect(() => {
        const checkAndUpdateStep = async () => {
            const stepFromServer = await getCurrentStep();
            if (stepFromServer !== currentFormStep) {
                setCurrentFormStep(stepFromServer);
            }
        };
        ReactGA.initialize(googleAnalyticsID);
        checkAndUpdateStep();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const FormStepsTracker = [
        <Welcome nextStep={nextStep} currentFormStep={currentFormStep} maxStep={maxStep}/>,
        <SubjectIntroduction nextStep={nextStep} currentFormStep={currentFormStep} maxStep={maxStep}/>,
        <TeacherAndStudents nextStep={nextStep} currentFormStep={currentFormStep} maxStep={maxStep}/>,
        <SubjectContent nextStep={nextStep} currentFormStep={currentFormStep} maxStep={maxStep}/>,
        <StudentProfiles nextStep={nextStep} currentFormStep={currentFormStep} maxStep={maxStep}/>,
        <TimelineAndGrading nextStep={nextStep} currentFormStep={currentFormStep} maxStep={maxStep}/>,
        <MutualAgreement nextStep={nextStep} currentFormStep={currentFormStep} maxStep={maxStep}/>,
        <Thanks nextStep={nextStep} currentFormStep={currentFormStep} maxStep={maxStep}/>,
        <FormSubmitted/>
    ];

    return FormStepsTracker[currentFormStep]
}

export default App;
